<template>
  <div class="staff">
    <div class="staff-container">
      <div class="left-container">
        <tree
          :placeholder="placeholder"
          :companyList="staffAndDepartmentList"
          :departmentId="staffAndDepartmentId"
          @selectTreeNodeList="selectTreeNodeList"
        />
      </div>

      <div class="right-container">
        <div class="top-container">
          <div class="title-container">
            <span class="title">{{ departmentName }}</span>
            <el-input
              class="gray white"
              placeholder="搜索成员名称"
              prefix-icon="el-icon-search"
              v-model="searchStaff"
              clearable
              @keyup.enter.native="searchPeople"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleFreeUser
                ) !== -1
              "
              type="text"
              class="btn-blue"
              @click="stayDistribution"
              >待分配</el-button
            >
            <el-button
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleChangeDept
                ) !== -1
              "
              type="text"
              class="btn-gray"
              @click="changeDepartment"
              >变更部门</el-button
            >
            <el-button
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleOnLoanOnLoanConfirm
                ) !== -1
              "
              type="text"
              class="btn-border-text-blue"
              @click="openSecondList"
              >借调确认</el-button
            >
            <!-- <el-button type="text" class="btn-red">操作离职</el-button> -->
          </div>
        </div>
        <div class="table" v-if="tableData.length > 0">
          <el-table
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="60"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="120">
              <template slot-scope="scope">
                <div class="table-name">
                  <img class="table-img" :src="scope.row.img" />
                  <p>{{ scope.row.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
            />
            <el-table-column label="操作" min-width="120">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="btn-text"
                  @click="lookDetails(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  v-if="
                    scope.row.identity == 1 &&
                    OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleOnLoanOnLoanConfirm
                    ) !== -1
                  "
                  type="text"
                  class="btn-text"
                  @click="openSecond(scope.row)"
                  >借调</el-button
                >
                <el-button
                  v-if="scope.row.identity == 2"
                  type="text"
                  class="btn-text"
                  @click="releaseSecondment(scope.row)"
                  >解除借调</el-button
                >
              <el-dropdown
                trigger="click"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  <el-button
                    type="text"
                    class="btn-text"
                  >
                    更多
                    <i class="el-icon-caret-bottom"></i>
                  </el-button>
                </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command="beforeHandleCommand(scope.row, 'moveToPendingAssignment')">移至待分配</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="warning" v-else>
          <i class="el-icon-warning"></i>
          当前部门尚未有成员
        </div>
        <div v-if="tableData.length == 0" class="nothing">
          <div>
            <div>
              <img src="../../../../assets/nothing.png" />
            </div>
            <p>当前部门没有成员</p>
          </div>
        </div>
        <el-drawer
          :visible.sync="drawer"
          :size="400"
          :modal="false"
          :with-header="false"
        >
          <div class="drawer-title">
            <i class="el-icon-close" @click="closeDrawer"></i>
            <div v-if="isFlag === 1">
              <el-button type="text" class="btn-gray" @click="closeDrawer"
                >取消</el-button
              >
              <el-button
                type="text"
                class="btn-blue"
                @click="submitForm('ruleForm')"
                >保存</el-button
              >
            </div>
            <div v-else>
              <el-button
                v-if="
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleUpdateUser
                  ) !== -1
                "
                type="text"
                class="btn-gray"
                @click="modStaff"
                >编辑</el-button
              >
              <el-button
                v-if="
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleChangeDept
                  ) !== -1
                "
                type="text"
                class="btn-gray"
                @click="changeDepartmentDrawer"
                >变更部门</el-button
              >
              <!-- <el-button type="text" class="btn-red">操作离职</el-button> -->
            </div>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            v-if="isFlag !== 2"
          >
            <el-form-item>
              <div class="mod-img">
                <div class="mod-img-left">
                  <img
                    :src="
                      ruleForm.uploadImages.length > 0
                        ? ruleForm.uploadImages[0]
                        : avater
                    "
                  />
                  <p>{{ ruleForm.name }}</p>
                </div>
                <!-- <el-upload
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :class="ruleForm.uploadImages.length < 1 ? '' : 'none'"
                  :limit="1"
                  multiple
                  :on-exceed="handleLimit"
                  :before-upload="uploadClaimImg"
                >
                  <el-button slot="trigger" type="text" class="btn-text"
                    >点击修改头像</el-button
                  >
                </el-upload> -->
              </div>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input class="gray white" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="ruleForm.status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-select v-model="ruleForm.sex" placeholder="请选择">
                <el-option
                  v-for="item in sexList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
              <el-input
                class="gray white"
                v-model="ruleForm.createTime"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input
                class="gray white"
                v-model="ruleForm.department"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="职级" prop="rank">
              <el-select v-model="ruleForm.rank" placeholder="请选择">
                <el-option
                  v-for="item in rankList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人员编制" prop="staffEstablishing">
              <el-select
                v-model="ruleForm.staffEstablishing"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in staffEstablishingList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="政治面貌" prop="politicalOutlook">
              <el-select v-model="ruleForm.politicalOutlook" placeholder="请选择">
                <el-option
                  v-for="item in politicalOutlookList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div v-else class="details">
            <div class="row zzd-info">
              <div class="mod-img-left">
                <img :src="avater" />
                <p>{{ ruleForm.name }}</p>
              </div>
              <div class="zzd-id">
                浙政钉ID：{{ ruleForm.zzdId }}
              </div>
            </div>
            <div class="row">
              <p class="sub-title">姓名</p>
              <p>{{ ruleForm.name }}</p>
            </div>
            <div class="row">
              <p class="sub-title">状态</p>
              <p>{{ statusVal }}</p>
            </div>
            <div class="row">
              <p class="sub-title">性别</p>
              <p>{{ sexVal }}</p>
            </div>
            <div class="row">
              <p class="sub-title">创建时间</p>
              <p>{{ ruleForm.createTime }}</p>
            </div>
            <div class="row">
              <p class="sub-title">部门</p>
              <p>{{ ruleForm.department }}</p>
            </div>
            <div class="row">
              <p class="sub-title">职级</p>
              <p>{{ rankVal }}</p>
            </div>
            <div class="row">
              <p class="sub-title">人员编制</p>
              <p>{{ staffEstablishingVal }}</p>
            </div>
            <div class="row">
              <p class="sub-title">政治面貌</p>
              <p>{{ politicalOutlookVal }}</p>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>

    <!-- 变更部门 -->
    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <div class="company-container" v-if="isSecond == 2">
        <tree
          :companyList="companyList"
          :departmentId="departmentId"
          @selectTreeNodeList="selectDepartmentList"
        />
      </div>
      <div class="company-container" v-else>
        <tree
          :companyList="allCompanyList"
          :departmentId="departmentId"
          @selectTreeNodeList="selectDepartmentList"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 待分配人员 -->
    <el-dialog
      title="待分配人员"
      :visible.sync="stayDistributionDialogVisible"
      width="940px"
      :before-close="stayDistributionClose"
    >
      <div class="stayDistribution">
        <div class="table table-left">
          <div class="search-table">
            <el-input
              class="gray white"
              @keyup.enter.native="searchAssignPeople"
              v-model="staff"
              placeholder="请输入成员"
            ></el-input>
          </div>
          <el-table
            :data="assignPeople"
            style="width: 100%"
            height="300"
            @selection-change="handleSelectionStayDistributionChange"
          >
            <el-table-column type="selection" width="60"> </el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <div class="assign-name">
                  <img :src="scope.row.image" />
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="organizationPath" label="组织汇报线"></el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="stayDistributionTotalNum"
              :currentPage="stayDistributionCurrentPage"
              @queryChange="stayDistributionOnQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="table-right">
          <p class="title">设置人员归属部门时，需选中四级子部门</p>
          <tree
            :companyList="companyList"
            :departmentId="assignDepartmentId"
            :isSearch="isSearch"
            @selectTreeNodeList="selectAssignDepartment"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stayDistributionDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="stayDistributionConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 借调确认 -->
    <el-dialog
      title="借调确认"
      :visible.sync="secondDialogVisible"
      width="720px"
      :before-close="secondClose"
    >
      <div>
        <div class="table">
          <el-table :data="secondList" style="width: 100%" height="250">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column
              prop="sourceDeptName"
              label="借出部门"
            ></el-table-column>
            <el-table-column
              prop="targetDeptName"
              label="调入部门"
            ></el-table-column>
            <el-table-column label="操作" min-width="120">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="btn-text"
                  @click="accepts(scope.row)"
                  >接受</el-button
                >
                <el-button
                  type="text"
                  class="btn-text-red"
                  @click="reject(scope.row)"
                  >驳回</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="secondClose">取 消</el-button>
        <el-button type="primary" @click="secondConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import Tree from "@/components/Tree.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Staff from "@/models/staff.js";
import Department from "@/models/department.js";
import { formaTimeToMinute, mapChild, mapId2 } from "@/common/js/utils.js";
import { getTeamId } from "common/js/storage";
import { operationMixins } from "@/common/mixins/operation/operation.js";
import ImgUploader from "@/models/img-upload.js";
const imgUploader = new ImgUploader();
export default {
  mixins: [operationMixins],
  components: {
    Tree,
    PaginationTpl,
  },

  data() {
    return {
      avater: require("../../../../assets/avater.png"),
      staffAndDepartmentId: 0,
      staffAndDepartmentList: [] /* 成员与部门数据 */,
      searchStaff: '',
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      tableTitleList: [
        // { prop: "phone", lable: "手机号", width: "" },
        { prop: "deptName", lable: "部门", width: "" },
        { prop: "sex", lable: "性别", width: "" },
        { prop: "rankName", lable: "职级", width: "" },
      ],
      departmentName: "",
      placeholder: "搜索部门",
      selectId: [],
      selectIdDrawer: [],
      /* 1: 抽屉外的变更部门按钮；2：抽屉内的变更部门按钮 */
      isChangeDeptDrawer: 1,
      titleDialog: "变更部门",
      /* 是否是发起借调；1:是；2是变更部门 */
      isSecond: 2,
      secondUserId: "",
      secondDialogVisible: false,
      /* 借调列表 */
      secondList: [],
      selectPeopleBelongDeptId: '',

      /* -------------------   以下是抽屉的字段  ---------------*/
      isFlag: 1 /* 标记;  1: 编辑; 2： 详情 */,
      drawer: false,
      loading: false,
      fileList: [],
      ruleForm: {
        id: "",
        uploadImages: [],
        name: "",
        status: 1,
        sex: 1,
        createTime: "",
        department: "",
        rank: "",
        staffEstablishing: "",
        politicalOutlook: "",
        zzdId: ''
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      statusList: [
        {
          name: "正常",
          id: "A",
        },
        {
          name: "离职",
          id: "F",
        },
      ],
      sexList: [
        {
          name: "男",
          id: 1,
        },
        {
          name: "女",
          id: 2,
        },
      ],
      rankList: [],
      staffEstablishingList: [],
      politicalOutlookList: [],
      statusVal: "正常",
      sexVal: "男",
      rankVal: "",
      staffEstablishingVal: "",
      politicalOutlookVal: "",

      /* --------------------  以下是变更部门字段   ---------------- */
      dialogVisible: false,
      companyList: [] /* 变更部门数据 */,
      allCompanyList: [] /* 变更部门数据 */,
      departmentId: 0,
      sourceDeptId: 0,

      /* -------------------  以下是待分配字段 ------------------------ */
      assignDepartmentId: 0,
      stayDistributionDialogVisible: false,
      staff: "",
      assignPeople: [],
      selectAssignPeople: [],
      stayDistributionTotalNum: 0,
      stayDistributionCurrentPage: 1,
      isSearch: false,
    };
  },

  created() {
    config();
    this.initDepartmentList();
    this.initRankList();
    this.initPoliticalFaceList();
    this.initStaffingList();
    this._getAssignPeopleList();
    this.initAllDapartmentList();
  },
  mounted() {},

  methods: {
    initStaffList() {
      let queryStr = this.searchStaff;
      let id =
        (this.staffAndDepartmentId != 0 && this.staffAndDepartmentId != 1)
          ? this.staffAndDepartmentId
          : getTeamId();
      let currentPage = this.currentPage;
      Staff.getPeopleList(id, queryStr, currentPage).then((res) => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.departmentId = i.departmentId;
            obj.identity = i.identity;
            obj.phone = i.phoneNo;
            obj.deptName = i.deptName;
            obj.sex = i.sex == 1 ? "男" : "女";
            obj.job = i.position ? i.position : "—";
            obj.rankName = i.rankName ? i.rankName : "—";
            obj.img = i.image ? i.image : this.avater;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    searchPeople() {
      this.currentPage = 1;
      this.initStaffList()
    },

    /* 获取变更部门数据 */
    initDepartmentList() {
      let searchDepartment = "";
      let id = "";
      let keyword = ''
      Staff.getChangeDepartmentList(id, searchDepartment, keyword).then((res) => {
        if (res.success) {
          let arr = mapChild(res.result);
          let arr2 = mapChild(res.result);
          this.staffAndDepartmentList = mapId2(arr);
          if (this.staffAndDepartmentList.length>0 && this.staffAndDepartmentList[0].subList.length>0) {
            this.staffAndDepartmentId = this.staffAndDepartmentList[0].subList[0].id
            this.departmentName = this.staffAndDepartmentList[0].subList[0].departmentName;
            this.$bus.emit('defaultSelectFristTwoDeptment', this.staffAndDepartmentId)
            this.initStaffList();
          }
          this.companyList = mapId2(arr2);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取所有支队 */
    initAllDapartmentList() {
      let searchDepartment = "";
      let id = "";
      Department.getDepartmentList(id, searchDepartment).then((res) => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.allCompanyList = mapId2(arr);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* ----------------------------  以下是抽屉的方法  ------------------------ */
    /* 获取职级 */
    initRankList() {
      Staff.getRankList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.code = i.code;
            arr.push(obj);
          });
          this.rankList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取政治面貌 */
    initPoliticalFaceList() {
      Staff.getPoliticalFaceList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.code = i.code;
            arr.push(obj);
          });
          this.politicalOutlookList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取人员编制 */
    initStaffingList() {
      Staff.getStaffingList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.code = i.code;
            arr.push(obj);
          });
          this.staffEstablishingList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取详情 */
    _getDetailsList() {
      let id = this.ruleForm.id;
      let deptId =
        this.staffAndDepartmentId != 0
          ? this.staffAndDepartmentId
          : getTeamId();
      Staff.getDetailsList(id, deptId).then((res) => {
        if (res.success) {
          let rankObj = this.rankList.find(item => {return item.name == res.result.rank})
          let politicalFaceObj = this.politicalOutlookList.find(item => {return item.name == res.result.politicalFace})
          let staffingObj = this.staffEstablishingList.find(item => {return item.name == res.result.staffing})
          this.ruleForm.name = res.result.name;
          this.ruleForm.zzdId = res.result.zzdId;
          this.ruleForm.uploadImages = [res.result.image];
          this.ruleForm.rank = rankObj?.code;
          this.ruleForm.sex = Number(res.result.sex);
          this.ruleForm.department = res.result.deptName;
          this.ruleForm.status = res.result.status;
          this.ruleForm.staffEstablishing = staffingObj?.code;
          this.ruleForm.politicalOutlook = politicalFaceObj?.code;
          this.ruleForm.createTime = formaTimeToMinute(res.result.createTime);
          this.rankVal = res.result.rank;
          this.statusVal = res.result.status == "A" ? "正常" : "离职";
          this.sexVal = res.result.sex == 1 ? "男" : "女";
          this.staffEstablishingVal = res.result.staffing;
          this.politicalOutlookVal = res.result.politicalFace;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取选中树节点的数据 */
    selectTreeNodeList(v) {
      if (v.id != 1) {
        this.staffAndDepartmentId = v.id;
        this.departmentName = v.departmentName;
        this.currentPage = 1
        this.initStaffList();
      }
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initStaffList();
    },

    /* 多选 */
    handleSelectionChange(val) {
      let arr = [];
      val.map((i) => {
        arr.push(i.id);
      });
      this.selectId = arr;
      this.selectPeopleBelongDeptId = val.length > 0 ? val[0].departmentId:''
    },

    /* 查看详情 */
    lookDetails(row) {
      this.isFlag = 2;
      this.drawer = true;
      this.ruleForm.id = row.id;
      this.selectIdDrawer = [row.id]
      this.selectPeopleBelongDeptId = row.departmentId
      this._getDetailsList();
    },

    closeDrawer() {
      this.drawer = false;
    },

    /* 编辑成员 */
    modStaff() {
      this.isFlag = 1;
    },

    /* 图片数量大于1 */
    handleLimit() {
      this.$message({
        message: "图片数量最多1张",
        type: "warning",
      });
    },

    /* 上传 */
    uploadClaimImg(file) {
      this.fileList = [];
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.ruleForm.uploadImages = [];
              this.fileList.map((value) => {
                this.ruleForm.uploadImages.push(value.url);
              });
            } else {
              this.loading = false;
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.ruleForm.id;
          let name = this.ruleForm.name;
          let image =
            this.ruleForm.uploadImages.length != 0
              ? this.ruleForm.uploadImages[0]
              : "";
          let rank = this.ruleForm.rank;
          let sex = this.ruleForm.sex;
          let status = this.ruleForm.status;
          let staffing = this.ruleForm.staffEstablishing;
          let politicalFace = this.ruleForm.politicalOutlook;
          let createTime = this.ruleForm.createTime;
          let deptName = this.ruleForm.department;
          let data = {
            id,
            name,
            image,
            rank,
            sex,
            status,
            staffing,
            politicalFace,
            createTime,
            deptName,
          };
          Staff.postModStaffList(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.initStaffList();
              this.closeDrawer();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* --------------------------------- 以下是变更部门方法  ------------------------ */
    changeDepartmentCommon() {
      this.titleDialog = "变更部门";
      this.isSecond = 2;
      this.dialogVisible = true;
    },
    changeDepartment() {
      if (this.selectId.length == 0) {
        this.$message({
          type: "error",
          message: "请先选择成员",
        });
        return;
      }
      this.isChangeDeptDrawer = 1
      this.changeDepartmentCommon()
    },
    changeDepartmentDrawer() {
      this.isChangeDeptDrawer = 2
      this.changeDepartmentCommon()
    },

    handleClose() {
      this.dialogVisible = false;
    },

    /* 获取选中变更部门树节点的数据 */
    selectDepartmentList(v) {
      this.departmentId = v.id2;
    },

    /* 变更部门和借调确认 */
    confirm() {
      if (this.isSecond == 2) {
        let userIdList = this.isChangeDeptDrawer == 1?this.selectId:this.selectIdDrawer;
        let targetDeptId = this.departmentId;
        let sourceDeptId = this.selectPeopleBelongDeptId;
        if (userIdList.length == 0) {
          this.$message({
            type: "error",
            message: "请先选择成员",
          });
          return;
        }
        let data = {
          userIdList,
          targetDeptId,
          sourceDeptId,
        };
        Staff.postSelectDepartmentList(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "变更部门成功",
            });
            this.initStaffList();
            this.handleClose();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      } else {
        let userId = this.secondUserId;
        let targetDeptId = this.departmentId;
        let sourceDeptId = this.sourceDeptId;
        let data = {
          userId,
          targetDeptId,
          sourceDeptId,
        };
        Staff.postSecond(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "借调成功",
            });
            this.initStaffList();
            this.handleClose();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    /* ----------------------------------  以下是待分配方法 ------------------------ */
    /* 获取待分配人员 */
    _getAssignPeopleList() {
      let id = "";
      let staff = this.staff;
      let currentPage = this.stayDistributionCurrentPage;
      Staff.getTwoLeverAssignPeopleList(id, staff, currentPage).then((res) => {
        if (res.success) {
          let arr = [];
          this.stayDistributionTotalNum = res.result.totalNum;
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.image = i.image;
            obj.phone = i.phoneNo;
            obj.organizationPath = i.organizationPath;
            arr.push(obj);
          });
          this.assignPeople = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    stayDistribution() {
      this.stayDistributionDialogVisible = true;
    },

    stayDistributionClose() {
      this.stayDistributionDialogVisible = false;
    },

    /* 待分配多选 */
    handleSelectionStayDistributionChange(val) {
      let arr = [];
      val.map((i) => {
        arr.push(i.id);
      });
      this.selectAssignPeople = arr;
    },

    /* 待分配确认 */
    stayDistributionConfirm() {
      if (this.assignDepartmentId == 0) {
        this.$message.error("请先选择部门");
        return;
      }
      let userIdList = this.selectAssignPeople;
      let targetDeptId = this.assignDepartmentId;
      let data = {
        userIdList,
        targetDeptId,
      };
      Staff.postSaveAssignPeople(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "设置成功",
          });
          this.initStaffList();
          this.stayDistributionClose();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    selectAssignDepartment(v) {
      this.assignDepartmentId = v.id;
    },
    searchAssignPeople() {
      this.stayDistributionCurrentPage = 1;
      this._getAssignPeopleList();
    },

    /* 待分配翻页 */
    stayDistributionOnQueryChange(data) {
      this.stayDistributionCurrentPage = data.currentPage;
      this._getAssignPeopleList();
    },

    /* 打开借调 */
    openSecond(row) {
      this.secondUserId = row.id;
      this.sourceDeptId = row.departmentId;
      this.titleDialog = "发起借调";
      this.isSecond = 1;
      this.dialogVisible = true;
    },

    /* 解除借调 */
    releaseSecondment(row) {
      this.$confirm("成员借调解除后需再次发起，是否继续？", "确认解除借调", {
        confirmButtonText: "解除",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          userId: row.id,
          deptId: row.departmentId,
        };
        Staff.postReleaseSecondment(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "解除借调成功",
            });
            this.initStaffList();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      });
    },

    /* 借调列表 */
    async initSecondList() {
      let res = await Staff.postSecondList();
      if (res.success) {
        let arr = [];
        res.result.map((i) => {
          let obj = {};
          obj.id = i.id;
          obj.sourceDeptId = i.sourceDeptId;
          obj.sourceDeptName = i.sourceDeptName;
          obj.targetDeptId = i.targetDeptId;
          obj.targetDeptName = i.targetDeptName;
          obj.userId = i.userId;
          obj.name = i.userName;
          arr.push(obj);
        });
        this.secondList = arr;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },

    /* 打开借调列表 */
    openSecondList() {
      this.initSecondList();
      this.secondDialogVisible = true;
    },

    secondClose() {
      this.secondDialogVisible = false;
    },

    secondConfirm() {
      this.secondClose();
    },

    accepts(row) {
      let id = row.id;
      Staff.postAcceptsSecondStaff(id).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "接受借调人员成功",
          });
          this.initSecondList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    reject(row) {
      let id = row.id;
      Staff.postRejectSecondStaff(id).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "驳回借调人员成功",
          });
          this.initSecondList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command) {
      return {
        'value': value,
        command: command
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "moveToPendingAssignment":
          this.moveToPendingAssignment(command.value.id)
          break;
      }
    },

    /* 移至待分配 */
    moveToPendingAssignment(id) {
      this.$confirm("返回后方可添加至其他部门，是否确认？", "返回待分配", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        Staff.postMoveToPendingAssignment(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '移至待分配成功'
            });
            this.initStaffList()
            this._getAssignPeopleList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        }).catch(err => {
          console.log(err);
        }) 
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.staff {
  flex: 1;
  .staff-container {
    height: 100%;
    display: flex;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
  }
  .right-container {
    flex: 1;
    padding: 16px 20px;
    position: relative;
    .top-container {
      @include flex-between;
      margin-bottom: 16px;
      .title-container {
        @include flex-start;
        .title {
          font-size: $fs-medium-s;
          font-weight: 400;
          color: $color-BlackGrey;
          margin-right: 10px;
        }
        .el-input {
          flex: 1;
        }
      }
    }
    .table-name {
      @include flex-start;
    }
    .table-img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 8px;
    }
    .mod-img {
      @include flex-between;
      .mod-img-left {
        @include flex-start;
        font-size: $fs-small-l;
        color: $color-LightGrey;
        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
    .details {
      .row {
        margin-bottom: 22px;
        font-size: $fs-small-l;
        color: $color-BlackGrey;
        text-align: left;
        .sub-title {
          color: $color-LightGrey;
          margin-bottom: 10px;
        }
      }
      .zzd-info {
        @include flex-between;
        .zzd-id {
          font-weight: 400;
          font-size: $fs-small-l;
          color: $color-LightGrey;
        }
      }
      .mod-img-left {
        @include flex-start;
        font-size: $fs-small-l;
        color: $color-LightGrey;
        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
  }

  .stayDistribution {
    display: flex;
    .table-left {
      width: 470px;
      padding-right: 16px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 16px;
      }
    }
    .table-right {
      flex: 1;
      height: 400px;
      padding-left: 16px;
      box-sizing: border-box;
      overflow-y: auto;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 7px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
  }
}
</style>
<style lang="scss">
.staff {
  .assign-name {
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }
  .el-input__prefix,
  .el-input__suffix {
    top: 1px;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-form-item__label {
    line-height: 14px;
  }
  .el-dialog__body {
    padding: 10px 32px;
    .company-container {
      height: 360px;
      overflow-y: auto;
      background: $bg-ChangeDepartmentTree;
      padding: 16px 20px;
      .el-input__inner,
      .el-tree {
        background: $bg-ChangeDepartmentTree;
      }
    }
  }
  .warning {
    height: 32px;
    line-height: 32px;
    text-align: left;
    background: $bg-OriginYellow;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: $color-OriginYellow;
    padding-left: 12px;
    i {
      margin-right: 8px;
    }
  }
  .nothing {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @include flex-center;
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
  .el-dropdown {
    margin-left: 10px;
  }
}
</style>
